export default __webpack_public_path__ + "static/107988-a07be00b7945b8cb79939fabd735a5bb.jpg";